import axios from 'axios'

const normalizeListResponse = (response) => ({
  result: response?.data?.data?.data || [],
  total: response?.data?.data?.total || 0,
})

export const fetchLovList = async (params = {}) => {
  const response = await axios({
    method: 'GET',
    url: 'lovs',
    params: {
      page: params.page || 1,
      limit: params.limit || 200,
      ...params,
    },
  })

  return normalizeListResponse(response)
}

export const fetchLovChildrenByParentName = async (parentName) => {
  const parentResponse = await fetchLovList({
    name: parentName,
    parentsOnly: true,
    limit: 1,
  })

  const parentLov = parentResponse.result.find((lov) => lov.name === parentName)

  if (!parentLov) {
    throw new Error('LOV_NOT_FOUND')
  }

  const childrenResponse = await fetchLovList({
    parentId: parentLov.id,
    limit: 500,
  })

  return childrenResponse.result
}

export const updateLov = async ({ id, ...payload }) => {
  const response = await axios.put(`lovs/${id}`, {
    ...payload,
  })

  return response.data.data
}

export const batchUpdateLovOrder = async (items) => {
  const response = await axios.put('lovs/batch-order', {
    items,
  })

  return response.data
}

export const uploadLovIcon = async ({ id, file }) => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await axios.patch(`lovs/${id}/icon`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data.data
}
